export default {
  title: 'My Trips',
  noTrips: 'No Upcoming Trips',
  noTripsDescription: 'You have no scheduled trips at the moment.',
  whereTo: 'Where to?',
  cancel: 'Cancel',
  cancelSuccess: 'Trip cancelled successfully',
  cancelError: 'Failed to cancel trip',
  loadError: 'Failed to load trip data',

  // Status labels
  now: 'Now',
  active: 'Onboard',
  requested: 'Requested',
  reserved: 'Reserved',
  notUsing: 'Not Using',
  regular: 'Regular',
  waitlisted: 'Waitlisted',

  // Direction labels
  from: 'From',
  to: 'To',
  departure: 'Departure',
  arrival: 'Arrival',
  etd: 'ETD',
  eta: 'ETA',
  fromDeparture: 'From Departure',
  toArrival: 'To Arrival',

  // Location labels
  campus: 'Campus',
  stopToBeAssigned: 'Stop to be assigned',

  // Capacity summary labels (singular | plural, used with $tc())
  rider: '1 rider | {count} riders',
  bike: '1 bike | {count} bikes',
  wheelchair: '1 wheelchair | {count} wheelchairs',

  // Sentence-style status labels for requested/reserved with capacity
  requestedWithCapacity: 'Requested for {capacity}',
  reservedWithCapacity: 'Reserved for {capacity}',

  // Vehicle and driver labels
  vehicle: 'Vehicle',
  driver: 'Driver',

  // Alert confirmations
  cancelRequest: 'Cancel Request',
  areYouSureToCancel: 'Are you sure you want to cancel your request?',
  continue: 'Continue',

  deleteReservation: 'Delete Reservation',
  deleteReservationSingleDayMessage:
    'Are you sure you want to delete your reservation for the route <b>{0}</b> on <b>{1}</b> with {2} at <b>{3}</b>?',
  deleteReservationMultiDayMessage:
    'Are you sure you want to delete your reservation for the route <b>{0}</b> on <b>{1}</b> with {2} at <b>{3}</b>? This is a multi-day reservation. Do you want to delete the selected trip only or all days in this reservation?',
  deleteThisTripOnly: 'Delete This Trip Only',
  deleteAllDays: 'Delete All Days',
  deleteAllReservationsConfirmMessage: 'Please confirm that you want to delete ALL reservations on this route',
  delete: 'Delete',

  // Waitlist dialog
  removeFromWaitlistTitle: 'Remove from Waitlist?',
  leaveWaitlist: 'Leave Waitlist',
  keepMySpot: 'Keep My Spot',
  areYouSureToLeaveWaitlist: 'If you leave the waitlist for <b>{0}</b>, your spot will be released.',

  // Unsubscribe dialog
  stopTracking: 'Stop Tracking',
  stopTrackingMessage: 'Are you sure you want to stop tracking <b>{0}</b>?',

  // Change usage dialog
  confirmAbsence: 'Confirm Absence',
  confirmAttendance: 'Confirm Attendance',
  notAttendingMessage:
    'Please confirm that you will not be using the route <b>{0}</b> {1} <b>{2}</b> on <b>{3}</b>. If you will be absent for multiple days, you can edit dates.',
  attendingMessage:
    'Please confirm that you will be using the route <b>{0}</b> {1} <b>{2}</b> on <b>{3}</b>. If you will attend for multiple days, you can edit dates.',
  confirm: 'Confirm',
  editDates: 'Edit Dates',
  editDatesMessage: 'Select the date range you want to apply this change to.',
  editDatesStartRequired: 'Please select a start date.',
  editDatesEndInvalid: 'End date must be the same as or after the start date.',
  optOutFromShuttle: 'Opt Out from Shuttle',
  optOutFromVanpool: 'Opt Out from Vanpool',
  optOutMessageShuttle: 'Are you sure you want to opt out from using this shuttle route?',
  optOutMessageVanpool: 'Are you sure you want to opt out from using this vanpool route?',
  optOutConfirm: 'Opt-out',
  optOutSuccessMessage: 'You have opted out from <b>{0}</b>.',
};
